module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_innlandet_pos.0e9a0ebe.svg";